import { render, staticRenderFns } from "./abilityLookDetail.vue?vue&type=template&id=63493068&scoped=true"
import script from "./abilityLookDetail.vue?vue&type=script&lang=js"
export * from "./abilityLookDetail.vue?vue&type=script&lang=js"
import style0 from "./abilityLookDetail.vue?vue&type=style&index=0&id=63493068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63493068",
  null
  
)

export default component.exports